(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var grid = $('[data-grid]');
    if (!grid) return;
    var cards = $$('[data-card]');
    var max = Math.ceil(Math.max.apply(null, cards.map(function (c) { return parseInt(c.dataset.price, 10) || 0; }).concat([0])) / 1000) * 10 || 10;
    var st = { q: '', cats: [], max: max, sort: 'featured' };
    var qIn = $('[data-q]'), form = $('[data-search-form]'), panel = $('[data-panel]');

    // category counts; hide empty categories
    $$('[data-cat-row]').forEach(function (row) {
      var id = row.getAttribute('data-cat-row');
      var n = cards.filter(function (c) { return c.dataset.cats.indexOf(' ' + id + ' ') > -1; }).length;
      var out = row.querySelector('[data-cat-count]');
      if (out) out.textContent = n;
      if (!n) row.hidden = true;
    });
    var catGroup = $('[data-cat-group]');
    if (catGroup && !$$('[data-cat-row]').some(function (r) { return !r.hidden; })) catGroup.hidden = true;

    function apply() {
      var words = st.q.trim().toLowerCase().split(/\s+/).filter(Boolean);
      var vis = [];
      cards.forEach(function (c) {
        var ok = words.every(function (w) { return c.dataset.s.indexOf(w) > -1; }) &&
          (!st.cats.length || st.cats.some(function (id) { return c.dataset.cats.indexOf(' ' + id + ' ') > -1; })) &&
          parseInt(c.dataset.price, 10) <= st.max * 100;
        c.hidden = !ok;
        if (ok) vis.push(c);
      });
      var order = cards.slice();
      if (st.sort === 'low') order.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (st.sort === 'high') order.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else order.sort(function (a, b) { return a.dataset.i - b.dataset.i; });
      order.forEach(function (c) { grid.appendChild(c); });
      var n = vis.length, q = st.q.trim();
      $$('[data-shown]').forEach(function (e) { e.textContent = n ? '1–' + n : '0'; });
      $$('[data-shown-count]').forEach(function (e) { e.textContent = n; });
      var ql = $('[data-q-label]'); if (ql) ql.textContent = q ? ' for “' + q + '”' : '';
      var em = $('[data-empty]'); if (em) em.hidden = n > 0;
      var et = $('[data-empty-text]'); if (et) et.textContent = q ? 'No products found for “' + q + '” here.' : 'No products match these filters.';
      var act = $('[data-active]'); if (act) act.textContent = st.cats.length ? ' (' + st.cats.length + ')' : '';
      var chips = $('[data-chips]'); if (chips) chips.hidden = !!q;
      var qx = $('[data-q-clear]'); if (qx) qx.hidden = !q;
      if (form) form.classList.toggle('has-q', !!q);
      return n;
    }

    if (qIn) qIn.addEventListener('input', function () { st.q = qIn.value; apply(); });
    if (form) form.addEventListener('submit', function (e) {
      // stay on this page when the collection has matches; otherwise search the whole store
      if (!st.q.trim() || apply() > 0) { e.preventDefault(); qIn.blur(); }
    });
    $$('[data-q-clear]').forEach(function (b) { b.addEventListener('click', function () { st.q = ''; qIn.value = ''; apply(); qIn.focus(); }); });
    $$('[data-chip]').forEach(function (b) { b.addEventListener('click', function () { st.q = b.dataset.chip; qIn.value = st.q; apply(); }); });
    $$('[data-cat]').forEach(function (i) { i.addEventListener('change', function () { st.cats = $$('[data-cat]:checked').map(function (x) { return x.value; }); apply(); }); });
    try {
      var qcat = new URLSearchParams(window.location.search).get('cat');
      var qbox = qcat ? $$('[data-cat]').filter(function (x) { return x.value === qcat; })[0] : null;
      if (qbox) { qbox.checked = true; st.cats = [qcat]; apply(); }
    } catch (e) {}
    var pr = $('[data-price]');
    if (pr) { pr.max = max; pr.value = max; var po = $('[data-price-out]'); if (po) po.textContent = max; }
    if (pr) pr.addEventListener('input', function () { st.max = parseInt(pr.value, 10); var o = $('[data-price-out]'); if (o) o.textContent = st.max; apply(); });
    $$('[data-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        st = { q: '', cats: [], max: max, sort: st.sort };
        if (qIn) qIn.value = '';
        $$('[data-cat]').forEach(function (x) { x.checked = false; });
        if (pr) { pr.value = max; var o = $('[data-price-out]'); if (o) o.textContent = max; }
        apply();
      });
    });
    var sel = $('[data-sort]'); if (sel) sel.addEventListener('change', function () { st.sort = sel.value; apply(); });
    $$('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        var list = b.dataset.view === 'list';
        grid.classList.toggle('is-list', list);
        $$('[data-view]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
    function openPanel(on) { if (!panel) return; panel.classList.toggle('is-open', on); document.documentElement.style.overflow = on ? 'hidden' : ''; }
    $$('[data-open]').forEach(function (b) { b.addEventListener('click', function () { openPanel(true); }); });
    $$('[data-close]').forEach(function (b) { b.addEventListener('click', function () { openPanel(false); }); });
    if (panel) panel.addEventListener('click', function (e) { if (e.target === panel) openPanel(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openPanel(false); });

    // add to cart
    var toast = $('[data-toast]'), tt;
    function showToast(msg) { if (!toast) return; toast.querySelector('span').textContent = msg; toast.hidden = false; clearTimeout(tt); tt = setTimeout(function () { toast.hidden = true; }, 3500); }
    $$('[data-choose]').forEach(function (b) {
      b.addEventListener('click', function () {
        var o = b.closest('[data-card]').querySelector('[data-opts]');
        if (o) { o.hidden = !o.hidden; b.querySelector('span').textContent = o.hidden ? b.dataset.label : 'Pick one above'; }
      });
      b.dataset.label = b.querySelector('span').textContent;
    });
    $$('[data-add-id]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var card = b.closest('[data-card]'), main = card.querySelector('.ccp-add'), mainSpan = main && main.querySelector('span');
        var old = mainSpan ? mainSpan.textContent : '';
        b.disabled = true;
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: parseInt(b.dataset.addId, 10), quantity: 1 }] };
        if (drawer && drawer.getSectionsToRender) body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        fetch(root.dataset.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function (res) {
            if (main) { main.classList.add('is-done'); main.classList.remove('is-outline'); if (mainSpan) mainSpan.textContent = 'Added ✓'; }
            var o = card.querySelector('[data-opts]'); if (o) o.hidden = true;
            setTimeout(function () {
              if (main) { main.classList.remove('is-done'); if (main.hasAttribute('data-choose')) main.classList.add('is-outline'); if (mainSpan) mainSpan.textContent = main.dataset.label || old; }
            }, 1800);
            var opened = false;
            try { if (drawer && drawer.renderContents && res.sections) { drawer.renderContents(res); opened = true; } } catch (e) {}
            if (!opened) showToast('Added to cart');
            try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ccp' }); } catch (e) {}
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('[data-cart-count],.cart-count-bubble span[aria-hidden="true"]').forEach(function (e) { e.textContent = c.item_count; });
            }).catch(function () {});
          })
          .catch(function (err) { showToast((err && err.description) || 'Could not add to cart'); })
          .then(function () { b.disabled = false; });
      });
    });
    apply();
  }
  function boot() { document.querySelectorAll('[data-ccp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-ccp]')); });
})();
